/* global parseFloat */
/**
 * RateIt
 * 
 * @since 1.3.5
 * @author FriskaMax <support@friskamax.com>
 * @param {jQuery} $ 
 */
(function($) { 
    'use strict';
    
    $('.rateit').rateit({
        step: .5,
        resetable: false
    }).on('over', function ( event, value ) { 
        $(this).attr('title', value ? parseFloat(value).toFixed(1) : 0.0); 
    });
})(jQuery);